import * as React from 'react';
import { SVGProps } from 'react';

const SvgMarkets = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.487 12.986C8.843 14.274 8.23 14.5 8 14.5c-.23 0-.843-.226-1.487-1.514-.498-.997-.868-2.382-.979-3.986h4.932c-.11 1.604-.48 2.99-.98 3.986ZM10.492 7.5H5.508c.062-1.816.456-3.387 1.005-4.486C7.157 1.726 7.77 1.5 8 1.5c.23 0 .843.226 1.487 1.514.55 1.099.943 2.67 1.005 4.486ZM11.969 9c-.121 1.941-.59 3.666-1.278 4.918A6.508 6.508 0 0 0 14.424 9h-2.455Zm2.512-1.5h-2.489c-.066-2.144-.554-4.06-1.3-5.418a6.504 6.504 0 0 1 3.79 5.418Zm-10.473 0c.066-2.144.554-4.06 1.3-5.418A6.504 6.504 0 0 0 1.519 7.5h2.49ZM1.576 9a6.508 6.508 0 0 0 3.733 4.918C4.62 12.666 4.152 10.941 4.03 9H1.576ZM16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0Z"
      fill="#174174"
    />
  </svg>
);

export default SvgMarkets;
